import React from "react";

import { FaHandPointRight } from "react-icons/fa6";
import "./bath.css";
import Cards6 from "../../cards/Cards6";
import Cards5 from "../../cards//Cards5";
import Card7 from "../../cards/Cards7";
import Hero from "../hero/Hero";
import Hero1 from "../hero/Hero2";
import ContactForm from "../contact/ContactForm";
import SectionHeader from "../section/SectionHeader";
import kitchenBg from "../../../assets/images/banner-back-1.jpg";

const Bath = () => {
  return (
    <>
      <div className="container-fluid P-4">
        <SectionHeader
          title="BATHROOM RENOVATIONS"
          backgroundImage={kitchenBg}
          className=""
        />
      </div>

      <div className="my-3">
        <div className="row align-items-stretch g-0">
          <div
            className="col-lg-6 p-5 d-flex flex-column justify-content-center"
            style={{ backgroundColor: "#d8b163" }}
          >
            <h1
              className="text-light text-start mb-2"
              style={{
                fontFamily: "Barlow Condensed",
                fontSize: "1.5rem",
                fontWeight: "normal",
              }}
              data-sal="slide-right"
              data-sal-duration="800"
              data-sal-delay="300"
            >
              GTA's Top-Rated Budget Bathroom Renovation Experts – Quality You
              Can Trust!
            </h1>
            <p
              className="text-light text-start"
              style={{
                fontFamily: "Barlow Condensed",
                fontSize: "3.5rem",
                fontWeight: "bold",
              }}
              data-sal="slide-left"
              data-sal-duration="800"
              data-sal-delay="300"
            >
              10-YEARS UNLIMITED WARRANTY ON BATHROOM RENOVATION
            </p>
            <p
              className="text-light text-start"
              style={{
                fontFamily: "Barlow Condensed",
                fontSize: "1.5rem",
                fontWeight: "normal",
              }}
              data-sal="slide-down"
              data-sal-duration="800"
              data-sal-delay="300"
            >
              Budget-Friendly, Timely, Surpassing Expectations
            </p>
            <div
              className="text-start"
              data-sal="bounce"
              data-sal-duration="2000"
              data-sal-delay="600"
            >
              <a href="/contact">
              <button className="custom-button ">
                GET A QUOTE <FaHandPointRight className="pulse-icon" />
              </button>
              </a>
            </div>
          </div>

          <div className="col-lg-6 p-0">
            <img
              src="assets/Images/Bathroom/bath3.jpg"
              alt="bathroom"
              className="img-fluid w-100 h-100 object-fit-cover"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
      <div className="p-4">
        <div
          className="container py-4 "
          style={{
            backgroundColor: "#d8b163",
            borderRadius: "25px",
            marginTop: "2rem",
            fontFamily: "Barlow Condensed",
          }}
        >
          <div className="text-center px-3">
            <h1 data-sal='slide-down' data-sal-duration="2000" data-sal-delay="300" className="fw-semibold text-white" style={{ fontSize: "4rem" }}>
              VELAR HEIGHTS RENOVATION
            </h1>
            <h4 data-sal='slide-up' data-sal-duration="2000" data-sal-delay="300"
             className="text-white mb-4 fs-3">
              Upgrade Your Dream Bathroom Today!
            </h4>
            <p data-sal='slide-up' data-sal-duration="2000" data-sal-delay="300"
              className="text-white fs-5 mx-auto"
              style={{ maxWidth: "800px" }}
            >
              Your bathroom is more than just a functional space—it’s where you
              refresh, unwind, and begin each day. As one of the most frequently
              used rooms in your home, it should feel like a personal retreat,
              offering comfort and enjoyment every time you step in.
            </p>
            <button data-sal='slide-down' data-sal-duration="2000" data-sal-delay="300"
              className="btn btn-dark   px-4 py-2 mt-3 fw-semibold"
              style={{ background: "black" }}
            >
              GET STARTED TODAY!
            </button>
          </div>
        </div>

        <h1 data-sal='slide-up' data-sal-duration="2000" data-sal-delay="300"
          className="mt-5 text-center"
          style={{ fontFamily: "Barlow Condensed", fontSize: "3.5rem" }}
        >
          OUR COMMITMENT TO YOU
        </h1>

        <Cards6 />
        <Hero />
        <Card7 />
        <Hero1 />

        <h1
          className="mt-5 text-center"
          style={{
            fontFamily: "Barlow Condensed",
            fontSize: "5rem",
            fontWeight: "normal",
          }}
        >
          OUR LATEST WORK
        </h1>

        <Cards5 />
        <ContactForm />
      </div>
    </>
  );
};

export default Bath;
